export const EDIT_SUCCESS = 'Бонусная программа обновлена';
export const EDIT_ERROR = 'Не удалось обновить бонусную программу';
